//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // styles: null,
      height: null
    };
  },
  methods: {
    styles: function styles() {
      var styles = this.$styles();
      this.height = styles.remove("height");
      return styles;
    },
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    }
  }
};